import { Heading, Stack } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import { TripType } from '@eti/schema-types';
import { getBoundTitle, getBoundType } from '../../../../../widgets/trip-details/utils/format';
import type { BoundType, TravelerSeatMapPricesType } from '../../../models';
import { SegmentType } from '../../../../../constants/segmentTypesConstants';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import type { TravelerProductPreference } from './utils';
import { getSegmentTravelerSeatMap } from './utils';
import SegmentPreferences from './SegmentPreferences';

const boundSeatMapStackHeadingStyles = css`
  padding-bottom: 16px;
`;

export interface BoundSeatMapProps {
  bound: BoundType;
  boundIndex: number;
  travelerSeatMapPrices: TravelerSeatMapPricesType;
}

const BoundSeatMap = ({ bound, boundIndex, travelerSeatMapPrices }: BoundSeatMapProps) => {
  const { t } = useTranslation();
  const { journeyType, travelers } = useOrderDetails();

  const boundTitle = bound
    ? t(
        getBoundTitle(getBoundType(boundIndex), journeyType === TripType.MultiStop),
        parseInt(bound.boundId, 10) + 1,
      )
    : null;

  const boundTravelerSeatMapPrices = travelerSeatMapPrices.filter(
    (travelerSeatMapPrice) => travelerSeatMapPrice?.boundIndex === boundIndex,
  );

  return (
    <>
      <Heading as="h3" className={boundSeatMapStackHeadingStyles} level={2}>
        {boundTitle}
      </Heading>
      <Stack>
        {bound.segments.map((segment, index) => {
          if (segment.__typename === SegmentType.TRIP_SEGMENT) {
            const travelerPreferences: TravelerProductPreference[] = getSegmentTravelerSeatMap(
              boundIndex,
              boundTravelerSeatMapPrices,
              index / 2,
              travelers,
              t,
            );

            return (
              <SegmentPreferences
                key={segment.segmentId}
                segment={segment}
                travelerPreferences={travelerPreferences}
              />
            );
          }
          return null;
        })}
      </Stack>
    </>
  );
};

export default BoundSeatMap;
